<template>
<div id="wrapper">
  <b-overlay
    :show="loadingOverlay"
    rounded="sm"
  >
  <bo-header />
  <div class="page-content">
    <bo-sidebar />
    <router-view />
  </div>
  </b-overlay>  
</div>
</template>
<script>
import GlobalVue from '@/libs/Global'
import BoHeader from '@/components/backend/BoHeader.vue'
import BoSidebar from '@/components/backend/BoSidebar.vue'

export default {
  extends:GlobalVue,
  components: {
    BoHeader,
    BoSidebar
  }
}
</script>